#!/usr/bin/env bun

import kleur from "kleur";
import pkg from "../package.json" with { type: "json" };
import { diffCommand } from "./commands/diff";
import {
  hooksCommand,
  hooksInstallCommand,
  hooksUninstallCommand,
} from "./commands/hooks";
import { initCommand } from "./commands/init";

const { bold, cyan, green, yellow, red } = kleur;

function parseArgs(argv: string[]): {
  command?: string;
  subcommand?: string;
  args: string[];
  help: boolean;
  version: boolean;
} {
  return {
    command: argv[0],
    subcommand: argv[1],
    args: argv.slice(1),
    help: argv.includes("--help") || argv.includes("-h"),
    version: argv.includes("--version") || argv.includes("-v"),
  };
}

async function main() {
  const args = parseArgs(process.argv.slice(2));

  if (!args.command || args.help) {
    showHelp();
    return;
  }

  if (args.version) {
    console.log(pkg.version);
    return;
  }

  switch (args.command) {
    case "init":
      await initCommand(args.args);
      break;
    case "hooks":
      if (args.subcommand === "install") {
        await hooksInstallCommand();
      } else if (args.subcommand === "uninstall") {
        await hooksUninstallCommand();
      } else {
        await hooksCommand();
      }
      break;
    case "diff":
      await diffCommand(args.args);
      break;
    default:
      console.error(red(`✗ Unknown command: ${args.command}`));
      console.log(`\nRun ${bold("bmpr --help")} for available commands`);
      process.exit(1);
  }
}

function showHelp() {
  console.log(`
${bold(cyan("🚀 Bumper"))} - AI memory system for coding projects

${bold("Usage:")}
  bmpr <command> [options]

${bold("Commands:")}
  ${green("init")}       Initialize Bumper in your project
  ${green("hooks")}      Manage git hooks for auto-updating context
  ${green("diff")}       Show changes to context.md over time

${bold("Options:")}
  ${yellow("--help")}, ${yellow("-h")}          Show this help message
  ${yellow("--version")}, ${yellow("-v")}       Show version
  ${yellow("--cli")}, ${yellow("<program>")}  Setup CLI commands (use with 'init')

${bold("Examples:")}
  bmpr init
  bmpr init --cli claude-code
  bmpr init --cli opencode
  bmpr init --cli all
  bmpr hooks install
  bmpr diff --since main
  bmpr --help
`);
}

main().catch((error) => {
  console.error(
    red("✗ Error:"),
    error instanceof Error ? error.message : String(error),
  );
  process.exit(1);
});
